import { Badge, Box, Flex, Text, useColorModeValue } from "@chakra-ui/react";
import moment from "moment";
import React, { useCallback, useMemo } from "react";
import { BusTime } from "../../data/buses.api";
import BusArrivalTime from "./BusArrivalTime";

type Props = {
  busTime: BusTime;
  showScheduledTime?: boolean;
  onClick?: (busTime: BusTime) => void;
};

const BusTimeRow = ({ busTime, showScheduledTime, onClick }: Props) => {
  const hoverColour = useColorModeValue("blackAlpha.50", "whiteAlpha.50");

  return (
    <Flex
      alignItems="center"
      gap={3}
      onClick={() => onClick?.(busTime)}
      _hover={{ bg: hoverColour }}
      transition=".1s background"
      cursor="pointer"
      px={3}
      py={1}
      rounded="md"
    >
      <Badge colorScheme="blue" fontWeight="bold">
        {busTime.line}
      </Badge>
      <Text flex={1}>{busTime.destinationName}</Text>
      <BusArrivalTime busTime={busTime} showScheduledTime={showScheduledTime} />
    </Flex>
  );
};

export default BusTimeRow;
